import basePath from "base_path";
import ActionTypes from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {buildQuery} from "utils/uri";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {MatterId} from "common/types/matter";
import {DocumentId} from "common/types/document";

export default function fetchSecondaryDocument(requestor) {
  return createReduxPromiseAction(
    ActionTypes.SECONDARY_DOCUMENT_FETCH,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      matterId: MatterId,
      documentId: DocumentId,
      options?: Record<string, unknown>,
    ) => {
      return requestor
        .get(
          `${basePath}/organisation/${organisationId}/project/${projectId}/matter/${matterId}/document/${documentId}${buildQuery(
            options,
          )}`,
          {withCredentials: true},
        )
        .then(response => response.data);
    },
  );
}
